import Wrapper from '../../layout/Wrapper';
import CommissionPayoutViewPage from '../../screens/comission/CommissionPayoutViewPage';
import MetaComponent from '../../components/common/MetaComponent';

const metadata = {
    title: 'Commission Payout Detail',
    description: '',
};

export default function CommissionPayoutViewPageRoute() {
    return (
        <Wrapper>
            <MetaComponent meta={metadata} />
            <CommissionPayoutViewPage />
        </Wrapper>
    );
}
